export const inputValueUtil = (input) => {
  let type = '';
  if (input instanceof HTMLInputElement) {
    type = input.getAttribute('type');
  }

  switch (type) {
    case 'checkbox':
    case 'radio':
      return input.checked;
    default:
      return input.value;
  }
};
